// 📁 src/context/EnquiryContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../axiosClient";
import { useUser } from "../UserContext";

const EnquiryContext = createContext();

export const EnquiryProvider = ({ children }) => {
  const [newCount, setNewCount] = useState(0);
  const { user, loading } = useUser();

  const refreshNewCount = async () => {
    try {
      // ✅ Use backend badge endpoint
      const res = await api.get("/api/enquiries/count");
      const count = typeof res.data?.count === "number" ? res.data.count : 0;
      setNewCount(count);
    } catch (err) {
      console.error("Failed to refresh new enquiry count", err);

      // ✅ fallback: safe list count (won't crash)
      try {
        const listRes = await api.get("/api/enquiries");
        const list = Array.isArray(listRes.data)
          ? listRes.data
          : Array.isArray(listRes.data?.enquiries)
          ? listRes.data.enquiries
          : [];
        const count = list.filter((e) =>
          e?.status ? e.status === "New" : !!e?.isNew
        ).length;
        setNewCount(count);
      } catch (e2) {
        setNewCount(0);
      }
    }
  };

  useEffect(() => {
    // ✅ Don't depend on token (your user object sometimes won't have it)
    if (!loading && user?.isAdmin) {
      refreshNewCount();
    } else {
      setNewCount(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.isAdmin, loading]);

  return (
    <EnquiryContext.Provider value={{ newCount, refreshNewCount }}>
      {children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiryContext = () => useContext(EnquiryContext);
